<div class="search-trigger" (click)="visible = true">
  <i class="pi pi-search"></i>
  <span>Search</span>
  <span class="shortcut">{{ isMac ? '⌘' : 'Ctrl' }} + K</span>
</div>

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [showHeader]="false"
  position="top"
  [baseZIndex]="10000"
  [ngClass]="{
    'search-dialog': true,
    'has-results': results.length > 0
  }"
  [contentStyle]="{ padding: '1.5rem' }"
  (onHide)="clear()"
>
  <p-autoComplete
    [(ngModel)]="query"
    [suggestions]="results"
    (completeMethod)="onSearch($event)"
    (onSelect)="navigateTo($event)"
    field="label"
    [showClear]="true"
    placeholder="Search..."
    class="w-full"
    [dropdown]="false"
    [appendTo]="'self'"
  >
    <ng-template pTemplate="input">
      <div class="p-input-icon-left p-input-icon-right w-full">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [(ngModel)]="query"
          (input)="onSearch({ query })"
          placeholder="Search..."
          class="w-full"
        />
        @if (query) {
        <i class="pi pi-times" style="cursor: pointer" (click)="clear()"></i>
        }
      </div>
    </ng-template>

    <ng-template let-item pTemplate="item">
      <div class="search-item">
        <span class="sv-id"
          >[SV] #{{
            item.value.type === 'serviceValidation'
              ? item.value.id
              : item.value.serviceValidationId
          }}</span
        >
        <span
          class="entity-tag"
          [ngClass]="
            item.value.type === 'serviceValidation'
              ? 'customer-tag'
              : 'site-tag'
          "
        >
          {{ item.value.type === 'serviceValidation' ? 'Customer' : 'Site' }}
        </span>
        <span class="site-name">
          {{
            item.value.type === 'serviceValidation'
              ? item.value.customer
              : item.value.site
          }}
        </span>

        @if (item.value.type === 'matchedSite' && item.value.source !== 'site')
        {
        <span
          class="source-tag"
          [ngClass]="{
            'phone-source': item.value.source === 'phone',
            'address-source': item.value.source === 'address'
          }"
        >
          {{ item.value.source }}
        </span>

        <span class="highlighted-result">
          {{ getMatchParts(item.value.highlightTarget).before
          }}<mark>{{ getMatchParts(item.value.highlightTarget).match }}</mark
          >{{ getMatchParts(item.value.highlightTarget).after }}
        </span>
        }
      </div>
    </ng-template>
  </p-autoComplete>

  <ng-template pTemplate="footer">
    <div class="search-footer">
      <div class="shortcut"><span class="key">↵</span> to select</div>
      <div class="shortcut">
        <span class="key">↓</span> <span class="key">↑</span> to navigate
      </div>
      <div class="shortcut"><span class="key">esc</span> to close</div>
    </div>
  </ng-template>
</p-dialog>
